import CercleLinKButton from '@/components/phone/CercleLinKButton';
import DebutPanel from '@/components/phone/debut';
import LoginButton from '@/components/phone/loginButton';
import { Title } from '@/components/phone/Title';
import { getNewDebutTellers } from '@raysee/firestore';
import { PhonePhoneIcon } from '@raysee/icon';
import { PlanType } from '@raysee/schema';
import type { NextPage } from 'next';
import { NextSeo } from 'next-seo';
import Image from 'next/image';
import { Fragment } from 'react';
import useSWR from 'swr';
import { Container, Footer, Header, Main, withLayout } from '../../../components';

const Page: NextPage = () => {
  const { data } = useSWR('debut_tellers', () => getNewDebutTellers(), {
    revalidateOnMount: true,
    revalidateOnFocus: false,
  });
  const debutTellers =
    data?.filter((teller) => teller.newDebutPlanType !== PlanType.Chat).slice(0, 3) || [];

  return withLayout(
    <Container>
      <NextSeo
        title="初めての方へ電話占いRAYSEEのご紹介 ｜4,200円分無料、1分220円~｜口コミで当たると評判の電話レイシー"
        description="電話占いRAYSEEを初めてご利用されるお客様への案内ページです。おすすめのポイントやご利用料金、利用者の口コミなどを紹介。実力屈指の電話占い師があなたのお悩みに寄り添います。"
      />
      <Header />

      <Main>
        <section className="bg-phone-bg2">
          <div style={{ justifyItems: 'center' }}>
            <Image
              src={'/images/phone/welcome/top.png'}
              alt="電話占い"
              width="1560"
              height="3120"
            />
          </div>

          <div className="p-5 space-y-20">
            <div className="space-y-5">
              <Title title="はじめに" isCenter />

              <div className="font-serif font-bold text-gray-700 text-center">
                <div>この度は電話占いRAYSEEをご覧いただきありがとうございます。</div>
                <div>
                  電話占いが初めての方から、上級者の方まで使いやすいサービスを目指し当サービスの運営を行っております。
                  このページでは使い方やおすすめのポイントをご紹介させていただきます。
                </div>
              </div>
            </div>
          </div>
        </section>

        <Image src={'/images/phone/hr/50p_0.png'} alt="" width="1560" height="208" />

        <section className="py-10 m-5 space-y-10">
          <Title title="ここがおすすめ！" isCenter />

          <div className="space-y-2">
            <Image
              src={'/images/phone/welcome/image1.png'}
              alt="今すく無料登録"
              width="1424"
              height="600"
            />
            <div className="font-serif font-bold text-gray-700">
              <div>
                電話占いでは店舗等に行く必要がなく、お好きな場所・お好きな時間に鑑定が可能です。
              </div>
              <div>
                また電話で鑑定を行うため、顔を出す必要がなく、人に言えないような相談もオススメです。
              </div>
            </div>
          </div>
          <div className="space-y-2">
            <Image
              src={'/images/phone/welcome/image2.png'}
              alt="是非この機会にお試しください。"
              width="1424"
              height="600"
            />
            <div className="font-serif font-bold text-gray-700">
              <div>1分220円～とお手頃価格で鑑定可能です。</div>
              <div>また今なら初回限定で最大10分無料キャンペーン中！</div>
              <div>是非この機会にお試しください。</div>
            </div>
          </div>
          <div className="space-y-2">
            <Image
              src={'/images/phone/welcome/image3.png'}
              alt="全鑑定師予約・指名料無料です"
              width="1424"
              height="600"
            />
            <div className="font-serif font-bold text-gray-700">
              <div>全鑑定師予約・指名料無料です。</div>
              <div>
                他のサービスと違い大人気の先生でも必ず鑑定を受けられるところがRAYSEEの大きな魅力です。
              </div>
            </div>
          </div>
          <div className="space-y-2">
            <Image
              src={'/images/phone/welcome/image4.png'}
              alt="実力確かな占い師に是非お悩みをご相談ください。"
              width="1424"
              height="600"
            />
            <div className="font-serif font-bold text-gray-700">
              <div>弊社独自の厳しい選考を突破した占い師のみ在籍しております。</div>
              <div>実力確かな占い師に是非お悩みをご相談ください。</div>
            </div>
          </div>
        </section>

        <Image src={'/images/phone/hr/0_50p.png'} alt="" width="1560" height="208" />

        <section className="bg-phone-bg2 py-10 space-y-5 px-5">
          <Title title="こんなお悩みありませんか？" isCenter />
          <div className="bg-white border-2 border-phone-primary rounded-lg py-10 px-4 space-y-10">
            <div className="space-y-2">
              <Title
                title="復縁"
                textColorClassName="text-pink-500"
                textSizeClassName="text-2xl"
                isCenter
              />
              <div className="font-serif font-bold text-gray-700 text-lg text-center">
                <div>別れたあの人が忘れなれない・・・</div>
                <div>彼はどう思っているの？</div>
              </div>
            </div>
            <div className="space-y-2">
              <Title
                title="片思い"
                textColorClassName="text-pink-500"
                textSizeClassName="text-2xl"
                isCenter
              />
              <div className="font-serif font-bold text-gray-700 text-lg text-center">
                <div>彼の気持ちが知りたい・・・</div>
                <div>付き合うにはどうすれば？</div>
              </div>
            </div>
            <div className="space-y-2">
              <Title
                title="不倫"
                textColorClassName="text-pink-500"
                textSizeClassName="text-2xl"
                isCenter
              />
              <div className="font-serif font-bold text-gray-700 text-lg text-center">
                <div>誰にも相談できない・・・</div>
                <div>この先、どうなるの？</div>
              </div>
            </div>
            <div className="space-y-2">
              <Title
                title="恋人"
                textColorClassName="text-pink-500"
                textSizeClassName="text-2xl"
                isCenter
              />
              <div className="font-serif font-bold text-gray-700 text-lg text-center">
                <div>彼との今後が気になる・・・</div>
                <div>彼は運命の人なの？</div>
              </div>
            </div>
            <div className="space-y-2">
              <Title
                title="人生"
                textColorClassName="text-pink-500"
                textSizeClassName="text-2xl"
                isCenter
              />
              <div className="font-serif font-bold text-gray-700 text-lg text-center">
                <div>私はこの先どうなるの？</div>
                <div>この先良い出会いはある？</div>
              </div>
            </div>
            <div className="font-serif font-bold text-gray-700 text-lg text-center">
              <div>
                その他、将来の不安・金運や健康等、お客様の様々なお悩みを実力屈指の占い師が望む未来を掴み取るためのお手伝いをいたします。
              </div>
            </div>
          </div>
        </section>

        <Image src={'/images/phone/hr/50p_0.png'} alt="" width="1560" height="208" />

        <section className="my-16 px-5 space-y-8">
          <Title title="利用されたお客様の声" isCenter />
          <div className="font-serif font-bold text-gray-700 text-lg text-center">
            <div>
              電話占いRAYSEEではご利用いただいたお客様より口コミやご感想をいただく機能がございます。
            </div>
            <div>
              実際の占いを体験した方の口コミも占い師を選ぶ要素にしていただければと思います。
            </div>
          </div>

          <div className="space-y-10">
            <Image
              src={'/images/phone/welcome/voice1.png'}
              alt="復縁できました"
              width="1376"
              height="242"
            />

            <div className="bg-white border-2 border-phone-primary rounded-lg py-10 px-4 relative">
              <div className="h-20 w-20 absolute left-10 -top-9 bg-white">
                <Image
                  src={'/images/phone/welcome/letter.png'}
                  alt="お手紙"
                  width="1376"
                  height="242"
                />
              </div>
              <div className="font-serif font-bold text-gray-700 text-lg ">
                <div>藁にもすがる思いで1か月前に彼との復縁について視て頂きました。</div>
                <div>
                  復縁のことで相談しましたが、復縁を飛び越えて、彼とは結婚できるよ！とまでおっしゃっていただけて・・・その時は正直半信半疑でしたが（笑）先生のアドバイスをもとに彼に接した結果、ついに先日無事復縁することができました！
                </div>
                <div>
                  驚くことに、復縁したときに彼から「結婚を前提にもう一度付き合って欲しい。」と言われたんです！とてもうれしい気持ちでいっぱいです。彼の対応がまさに先生に言われた通りで・・・当たりすぎて怖いくらい（笑）先生のアドバイスを聞いていなければ、きっと復縁はできていなかったと思います。
                </div>
                <div>本当にありがとうございました！！</div>
              </div>
            </div>
          </div>

          <div className="space-y-10">
            <Image
              src={'/images/phone/welcome/voice2.png'}
              alt="先生のおかげ"
              width="1376"
              height="242"
            />

            <div className="bg-white border-2 border-phone-primary rounded-lg py-10 px-4 relative">
              <div className="h-20 w-20 absolute left-10 -top-9 bg-white">
                <Image
                  src={'/images/phone/welcome/letter.png'}
                  alt="お手紙"
                  width="1376"
                  height="242"
                />
              </div>
              <div className="font-serif font-bold text-gray-700 text-lg ">
                <div>
                  既婚者の彼と秘密の関係になって。さすがに私もいい歳だし彼との未来があるのなら一緒になりたいと思っていたんですが、「奥さんと別れるから」と彼が言ったものの離婚はしてくれず。ずるずると今の関係が続いて3年。でも彼のことが好きで別れることもできなくて・・・彼のことを信じて待てば良いか分からず、本当に毎日が辛く惨めに思えてしまいました。
                </div>
                <div>
                  どうにかしようと思って、先生に視てもらいました。そうしたら彼が私を本気で好きだと伝えていただき、思わずホッとして泣いてしまいました。まだ彼を好きでいても良いんだって。
                </div>
                <div>
                  もう少しだけ彼に時間をあげてくださいとアドバイスをいただきました。彼との縁を結びなおしてもらいました。先生から励ましをいただき元気が出たのでもう少しだけ待ってみることにしたら、彼から「離婚が成立した」と連絡が！驚きで声が出ませんでした！！今、彼と一緒になれて幸せです。ありがとうございました。
                </div>
              </div>
            </div>
          </div>
          <CercleLinKButton href="/reviews" text="口コミ一覧を見る" />
        </section>

        <section className="px-5 space-y-7 my-10">
          <Title title="相談料金とお支払いに関して" isCenter />
          <div className="text-phone-primary font-serif font-bold flex items-center justify-center text-center text-3xl">
            1分220円～利用可能！
          </div>
          <p className="font-bold text-center">
            24時間365日、実力屈指の占い師があなたの相談を お待ちしております。
          </p>
          <div>
            <p className="font-bold text-center">初めての方なら4200円分の鑑定が無料！</p>
            <p className="font-bold text-center">RAYSEEだからできる特典をご用意しました。</p>
          </div>
          <div>
            <div className="bg-phone-primary py-5 rounded">
              <h2 className="text-white text-3xl font-bold text-center font-serif">特別特典</h2>
              <div className="bg-white rounded-lg m-5 mb-0 py-5 flex">
                <PhonePhoneIcon width={36} height={36} className="mx-3" />
                <div className="flex items-end space-x-2">
                  <p className="text-brand">
                    <span className="text-2xl font-bold">2,200</span>
                    <span className="text-xl font-bold">円分</span>
                  </p>
                  <p className="font-bold">電話占い無料！</p>
                </div>
              </div>
            </div>
            <div className="mt-3 text-sm">
              <p>※初めての方に限り、お一人様1回限り</p>
            </div>
          </div>
        </section>

        <section>
          <Image src={'/images/phone/hr/0_50p.png'} alt="" width="1560" height="208" />
          <div className="bg-phone-bg2 py-6">
            <Title title="デビュー占い師" isCenter />
          </div>
          <Image src={'/images/phone/hr/50p_0.png'} alt="" width="1560" height="208" />
          {debutTellers.map((teller, i) => (
            <Fragment key={teller.id}>
              <DebutPanel teller={teller} />
              {i !== 2 && (
                <>
                  <Image src={'/images/phone/hr/0_50p.png'} alt="" width="1560" height="208" />
                  <div className="bg-phone-bg2 p-4" />
                  <Image src={'/images/phone/hr/50p_0.png'} alt="" width="1560" height="208" />
                </>
              )}
            </Fragment>
          ))}

          <Image src={'/images/phone/hr/0_50p.png'} alt="" width="1560" height="208" />
          <div className="bg-phone-bg2 p-4">
            <CercleLinKButton href="/phone/debut" text="デビュー占い師一覧へ" inverceTheme />
          </div>
          <Image src={'/images/phone/hr/50p_0.png'} alt="" width="1560" height="208" />
        </section>
        <div className="h-20 bg-[#3d2748]" />
        <Footer />
      </Main>
    </Container>,
    false,
  );
};

export default Page;
